<template>
    <div>
        <hr>

        <h3>What happens next?</h3>

        <p>You have chosen to get a delivery quote before making payment, this is a great way to determine costs before you've commited to payment.
        <div class="process-steps">
            <div class="row">
                <div class="col-md-4">
                    <h4>Step one</h4>
                    <p>You submit the order, we process it and calculate how much shipping will cost, this can take up to 48 hours.</p>
                    <p class="text-warning">Please note this may take longer during weekends</p>
                </div>
                <div class="col-md-4">
                    <h4>Step Two</h4>
                    <p>
                        Once we have a shipping cost, we will contact you via phone or email, to discuss and take payment.
                    </p>
                </div>
                <div class="col-md-4">
                    <h4>Step Three</h4>
                    <p>
                        When payment has been completed, we will package and ship your order that same day, if complete before 3pm, otherwise it will be the next working day.
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12 text-right">
                <button class="btn btn-green" @click="submit" :disabled="processing">
                    <template v-if="!processing">
                        <i class="fa fa-lock"></i> Submit Order
                    </template>
                    <template v-else>
                        <i class="fa fa-refresh fa-spin"></i> Processing
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkout from '../../../Services/Checkout.js';
    import Order from '../../../Services/Order';

    export default {
        props: ['gatewayId'],
        data() {
            return {
                processing: false,
                checkout: Checkout,
                order: Order.order,
            }
        },
        methods: {
            submit() {
                this.checkout.setType('Delivery Quotation')
                .setGatewayId(this.gatewayId).process(
                    undefined,
                    undefined,
                    this.order.reference,
                    this.order.notes
                ).then(response => {
                    this.$emit('complete');
                }).catch(error => {
                    this.$emit('failed');
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/Payments/GetDeliveryQuotationGateway.vue